import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconCursorMoveComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-CursorMove${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M8.5 3.733h-.1V7.267H11.933V5.24l2.592 2.592-2.592 2.592V8.4H8.4V11.933h2.025l-2.592 2.592-2.592-2.592h2.026V8.4H3.733v2.025L1.141 7.833l2.592-2.592v2.026H7.267V3.733H5.24l2.592-2.592 2.592 2.592H8.5z" fill={useCurrentColor ? 'currentColor' : '#000'} stroke="#fff" strokeWidth=".2"/></svg>;
}

const IconCursorMove = React.forwardRef(IconCursorMoveComponent);
export default IconCursorMove;
